import { isDefaultLanguage } from 'src/utils/i18n';

function fixLink(link, i18n) {
	if (link?.startsWith('/')) {
		if (!isDefaultLanguage(i18n.language)) {
			return `/${i18n.language}${link}`;
		}
	}

	return link;
}

export default fixLink;
